import type { Appearance } from "@clerk/types";

/**
 * Estilos extra para `<SignUp />` / `<SignIn />` embebidos (el logo global está en `ClerkProvider`).
 *
 * La tarjeta la pinta Clerk: `/registro` ya no envuelve el widget en otra Card,
 * porque anidarlas duplicaba encabezado, borde y padding, y empujaba el primer
 * campo fuera de la pantalla en mobile.
 */
export function getRegistroClerkAppearance(): Appearance {
  return {
    elements: {
      rootBox: "w-full mx-auto",
      headerTitle: "text-zinc-100",
      headerSubtitle: "text-zinc-400",
      footer: "text-zinc-500",
      cardBox:
        "w-full !shadow-2xl !shadow-black/40 border border-white/10 rounded-xl overflow-hidden",
      card: "bg-zinc-900/80 backdrop-blur px-5 py-6 sm:px-6",
    },
    variables: {
      colorPrimary: "hsl(var(--primary))",
      colorBackground: "transparent",
      colorText: "hsl(240, 5%, 95%)",
      colorTextSecondary: "hsl(240, 5%, 65%)",
      colorInputBackground: "hsl(240, 8%, 16%)",
      colorInputText: "hsl(240, 5%, 95%)",
      colorNeutral: "hsl(240, 5%, 95%)",
      borderRadius: "var(--radius)",
    },
  };
}
